import { TemplatePage } from './types';

const slideshowPage: TemplatePage = {
  header: {
    color: '#F1F1F1',
    icon: 'images/video-templates/slideshow.jpg',
    title: 'Slideshow Video Templates',
    title_meta: 'Free Slideshow Video Templates',
    description_meta:
      'Customize these slideshow video templates with your logo, text, and music. Add your own media and apply stunning ' +
      'filters and animations. Try free!',
    description:
      'Create a video presentation that looks stunning and professional. Customize these ready-made templates with your own ' +
      'text, visuals, colors, and logo. Viewers won’t be able to take their eyes off your video slideshow!'
  },
  footer: {
    category: 'Slideshow',
    description:
      'Give your marketing a boost through video. Make amazing videos for presentations, product demos, promotional ' +
      'campaigns, and events with our collection of video templates. Every template is professionally designed and fully ' +
      'customizable. '
  },
  content: [
    {
      type: 'templates',
      title: 'slideshow',
      search: { name: 'slide' }
    },
    {
      type: 'stocks',
      title: 'slideshow',
      search: { name: 'slideshow' }
    },
    { type: 'calendar' }
  ]
};

export default slideshowPage;
